/**
 * Formats a call message's parameter suffix text for the current
 * viewConfig.seqParamsMode (hotkey P, see UmlCanvasEngine.cycleSeqParamsMode):
 * 'hidden' -> nothing, 'types' -> just the type list (usually what actually
 * matters — a DTO type says more than its argument name), 'full' -> names
 * too. Shared between UmlSeqMessageWidget (what's actually drawn) and
 * AutoLayoutSeqDia (what's measured for collision/gap-widening) so the two
 * can never drift apart — a label auto-layout thinks fits is exactly what
 * gets rendered, params included.
 * @param {{name: string, type: string}[]|undefined} params
 * @param {'hidden'|'types'|'full'} mode
 * @returns {string|null} null when there's nothing to show
 */
export function formatSeqParams(params, mode) {
  if (mode === 'hidden' || !Array.isArray(params) || params.length === 0) {
    return null;
  }
  if (mode === 'types') {
    return `(${params.map(function typeOnly(p) { return p.type; }).join(', ')})`;
  }
  return `(${params.map(function nameAndType(p) { return `${p.name}: ${p.type}`; }).join(', ')})`;
}
